import {
    getRequest,
    patchRequest,
    postRequest,
} from "utils/helpers/common/http-methods";
import { MinorDTO } from "utils/helpers/models/attendee/minor.dto";
import { PostJoineeDTO } from "utils/helpers/models/host-dtos/postReviewJoinee.dto";

export const RSVP_APIs = {
    uploadFile: (body: FormData) => postRequest("/file/upload", body),
    getRsvpProfile: () => getRequest(`/user/profile`),
    changePassword: (body: any) => postRequest(`/create/password`, body),
    updateRsvp: (minorId: number, body: Partial<MinorDTO>) => patchRequest(`/attendee/minor/${minorId}/profile`, body),
    getRsvpEventHome: (params: any) =>getRequest(`/event/get/testing/refactored`, params),
    getEventById: (eventId: number) => getRequest(`/event/${eventId}/details`),
    getUserById: (id: number) => getRequest(`users/${id}`),
    getMyBadges: (params: any) => getRequest("/users/my/awarded/badges", params),
    toggleNotification: () => postRequest("/auth/notification-toggle", {}),
    getEventsReviews: (params:any) => getRequest(`/cup-of-gratitue/reviews/${params.eventId}`, params),
    getCupGradituteHostById: (id: number) => getRequest(`/cup-of-gratitue/event/${id}`),
    markAttendance: (eventId: number , attendeeId: number , childId: number , workshopSessionId: number) => postRequest(`/event/${eventId}/attend/${attendeeId}/${childId}/${workshopSessionId}`,{}),
    getEventAttendance: (eventId: number) => getRequest(`/event/${eventId}/attendance/new`),
    postReviewJoinee: (eventId: number,body:PostJoineeDTO) => postRequest(`/event/${eventId}/review-event-joinee`,body),
    contactUsSupport: (body: any) => postRequest("/contact-us-with-token", body),
    


    
};
